import { __decorate } from "tslib";
import { customElement, property } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { html } from 'lit';
let HlxErrorMapping = class HlxErrorMapping extends HelixElement {
    render() {
        return html `
            <slot></slot>
        `;
    }
};
__decorate([
    property({ type: String, reflect: true })
], HlxErrorMapping.prototype, "type", void 0);
HlxErrorMapping = __decorate([
    customElement('hlx-error-mapping')
], HlxErrorMapping);
export { HlxErrorMapping };
//# sourceMappingURL=error-mapping.js.map